import {
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import DriverLicenseInput from "../DriverLicenseInput"
import PassportInput from "../PassportInput"

const ProofOfIdentity = forwardRef(({ title, attributes, data, readOnly }, ref) => {

    const fieldsData = data || {}

    const passportRef = useRef()
    const driverLicenseRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const passportResult = passportRef.current?.validateAndGetData()
            const driverLicenseResult = driverLicenseRef.current?.validateAndGetData()

            return {
                isValid: (passportResult?.isValid ?? true) && (driverLicenseResult?.isValid ?? true),
                value: {
                    passport: passportResult?.value,
                    driverLicense: driverLicenseResult?.value,
                }
            }
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-base font-medium text-gray-700 mb-4">
                {title}
            </label>

            {
                attributes.find(attribute => attribute.key === "passport") && (
                    <PassportInput title={"Passport"} ref={passportRef} data={fieldsData.passport} readOnly={readOnly} />
                )
            }

            {
                attributes.find(attribute => attribute.key === "driver_license") && (
                    <DriverLicenseInput title={"Driver's License"} ref={driverLicenseRef} data={fieldsData.driverLicense} readOnly={readOnly} />
                )
            }
        </div>
    )
})

export default ProofOfIdentity
